import {
    Card,
    Box,
    Typography,
    Grid,
    IconButton
} from '@mui/material';

import {
    CancelOutlined,
    CheckCircleOutlined
} from '@mui/icons-material';

import { MoteColoredIcon } from "../../constants/mote";
import { third_party_constants } from "../../constants/third_party_constants";


const MoteSuggestionsComponent = () => {
    const { gmail } = third_party_constants;

    return (
        <Card
            raised
            sx={{
                width: '100%',
                background: 'white',
                borderRadius: '35px',
                padding: '5px',
                marginTop: '15px',
                height: "240px",
            }}
        >
            {/* TITLE */}
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    px: "1rem"
                }}
            >
                {/* MOTE ICON */}
                <MoteColoredIcon 
                    sx={{ 
                        fontSize: 48,
                        margin: '10px',
                    }}
                />

                {/* MOTE SUGGESTIONS */}
                <Typography
                    variant="h3"
                    fontWeight="bold"
                    sx={{
                        paddingLeft: '15px',
                        paddingTop: '10px',   
                        color: "#3B57B8"                     
                    }}
                >
                    Suggestions
                </Typography>
            </Box>

            {/* SUGGESTION */}
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mx: "1rem",
                    my: "1rem",
                    p: "1rem",
                }}
            >
                <Grid
                    container
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: '100%',
                    }}
                    spacing={2}
                >
                    {/* <Grid 
                        item 
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                        xs={6}
                    >
                        {gmail.icon({ fontSize: "large" })}
                    </Grid>
                    <Grid 
                        item 
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                        xs={6}
                    >
                        <Typography>
                            Draft an email to spencerwarezak@gmail.com about creating a pitch deck for the Apple acquisition deal.
                        </Typography>
                    </Grid> */}
                    <Grid
                        item
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                        xs={12}
                    >
                        <Typography color="#3B57B8">Suggestions coming soon!</Typography>
                    </Grid>
                </Grid>
            </Box>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    px: "1rem",
                    pb: "1rem",
                }}
            >
                <IconButton>
                    <CancelOutlined />
                </IconButton>
                <IconButton>
                    <CheckCircleOutlined />
                </IconButton>
            </Box>
        </Card>
    )
};

export default MoteSuggestionsComponent;